﻿let callbacks;

/**
 * Registers a function to be called when the DOM is ready.
 * @param {Function} fn - The function to be called when the DOM is ready.
 */
function ready(fn) {
	if (typeof fn != "function") {
		console.error("ready: function expected");
		return;
	}
	switch (document.readyState) {
		case "loading":
			if (callbacks == null) {
				callbacks = [fn];
				document.addEventListener("DOMContentLoaded", () => callbacks.forEach(fn => {
					try {
						fn();
					} catch (e) {
						console.error(fn.displayName || fn.name, e);
					}
				}));
			} else {
				callbacks.push(fn);
			}
			break;
		case "interactive":
		case "complete":
			fn();
			break;
	}
}

export { ready };
